import { jsxs, jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import "@emotion/react";
import { createContext, useContext, Fragment, useMemo } from "react";
import Icon from "./Icon.mjs";
import useThemeProps from "./useThemeProps.mjs";
import useUrlTransformer from "./useUrlTransformer.mjs";
import { useTranslation } from "react-i18next";
function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const clickableContext = createContext(null);
function getUrlType(url) {
  if (url.startsWith("#")) {
    return "anchor";
  }
  try {
    let {
      protocol,
      hostname
    } = new URL(url);
    if (protocol && protocol !== "http:" && protocol !== "https:") {
      return protocol.substring(0, protocol.length - 1);
    }
    if (hostname) {
      return "external";
    }
  } catch {}
  return "internal";
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "kk0iiy",
  styles: "padding:0 0.25em"
} : {
  name: "1bwmeu5-children",
  styles: "padding:0 0.25em;label:children;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
function useClickable(inProps) {
  const {
    t
  } = useTranslation();
  inProps = useThemeProps({
    props: inProps,
    name: "Clickable"
  });
  let {
    // as,
    elements = {},
    href,
    htmlFor,
    onClick,
    rel,
    target,
    to,
    type,
    uri,
    url,
    className,
    children,
    title,
    label,
    append,
    prepend,
    hideExternalIcon = false,
    externalIcon,
    ...restProps
  } = inProps;
  if (!children) {
    children = title ?? label;
    title = void 0;
    label = void 0;
  }
  const parentClickableContext = useContext(clickableContext);
  href = href != null && href !== "" ? href : to != null && to !== "" ? to : url != null && url !== "" ? url : uri != null && uri !== "" ? uri : null;
  const {
    transformUrl
  } = useUrlTransformer();
  href = transformUrl(href);
  if (target === "_blank") {
    rel = [... /* @__PURE__ */new Set([...(rel ? rel.split(/\s+/g) : []), "noopener", "noreferrer"])].join(" ");
  }
  let opensNewWindow = target === "_blank";
  children = /* @__PURE__ */jsxs(Fragment, {
    children: [prepend, children, opensNewWindow && !hideExternalIcon && /* @__PURE__ */jsx(Icon, {
      name: externalIcon,
      "aria-label": t(["wsui.base.clickable.opensNewWindow", "Opens new window"]),
      css: _ref
    }), append]
  });
  type = parentClickableContext && parentClickableContext.type !== "inert" ? "inert" : type || (htmlFor ? "label" : opensNewWindow ? "external" : href != null ? getUrlType(href) : onClick ? "button" : "inert");
  let isDisabled = inProps.disabled || inProps["aria-disabled"] === "true";
  let isInteractive = type !== "inert" && !isDisabled;
  let Element =
  // as ||
  type === "inert" ? elements.inert || "span" : type === "label" ? elements.label || "label" : type === "submit" ? elements.submit || elements.button || "button" : type === "reset" ? elements.reset || elements.button || "button" : type === "button" ? elements.button || "button" : elements[type] || elements.link || "a";
  const ElementWithProvider = useMemo(() => {
    if (parentClickableContext) {
      return Element;
    }
    const ElementWithContextProvider = _ref2 => {
      let {
        children: children2,
        ...props
      } = _ref2;
      return /* @__PURE__ */jsx(Element, {
        ...props,
        children: /* @__PURE__ */jsx(clickableContext.Provider, {
          value: {
            type
          },
          children: children2
        })
      });
    };
    return ElementWithContextProvider;
  }, [!!parentClickableContext, type, Element]);
  className = clsx(className, {
    "wsui-is-interactive": isInteractive,
    "wsui-is-disabled": isDisabled,
    "wsui-opens-new-window": opensNewWindow
  });
  return {
    Element: ElementWithProvider,
    type,
    isInteractive,
    isDisabled,
    opensNewWindow,
    props: {
      className,
      href,
      onClick,
      htmlFor,
      target,
      rel,
      type: type === "button" || type === "submit" || type === "reset" ? type : void 0,
      children,
      title,
      ...restProps
    }
  };
}
export { useClickable as default };